import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentBoard2Line = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.22528 3.75C6.69271 3.75 5.45117 4.99224 5.45117 6.52411V17.4759C5.45117 19.0078 6.69271 20.25 8.22528 20.25H16.2737C17.8054 20.25 19.0478 19.0076 19.0478 17.4759V6.52411C19.0478 4.99238 17.8054 3.75 16.2737 3.75H8.22528ZM3.95117 6.52411C3.95117 4.16408 5.86401 2.25 8.22528 2.25H16.2737C18.6339 2.25 20.5478 4.16395 20.5478 6.52411V17.4759C20.5478 19.8361 18.6339 21.75 16.2737 21.75H8.22528C5.86401 21.75 3.95117 19.8359 3.95117 17.4759V6.52411Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.95117 15.6016C3.95117 15.1873 4.28696 14.8516 4.70117 14.8516H19.7978C20.212 14.8516 20.5478 15.1873 20.5478 15.6016C20.5478 16.0158 20.212 16.3516 19.7978 16.3516H4.70117C4.28696 16.3516 3.95117 16.0158 3.95117 15.6016Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.58203 7.36719C8.58203 6.95297 8.91782 6.61719 9.33203 6.61719H12.4329C12.8471 6.61719 13.1829 6.95297 13.1829 7.36719C13.1829 7.7814 12.8471 8.11719 12.4329 8.11719H9.33203C8.91782 8.11719 8.58203 7.7814 8.58203 7.36719ZM8.58203 11.1508C8.58203 10.7365 8.91782 10.4008 9.33203 10.4008H15.165C15.5792 10.4008 15.915 10.7365 15.915 11.1508C15.915 11.565 15.5792 11.9008 15.165 11.9008H9.33203C8.91782 11.9008 8.58203 11.565 8.58203 11.1508Z",
			fill: "currentColor"
		})
	]
});
export default SvgDocumentBoard2Line;
